import type { BlockConfig } from 'components/editor/GridDndEditor/models/BlockConfig.model';
import { isCircularRadius } from 'components/editor/SidePanel/content/DesignSettings/Textblock/useCircularShape';

// Fraction of the border radius kept as inner spacing so text stays clear of rounded corners.
export const CORNER_INSET_RATIO = 1 / 20;

type TextBlockBoxStyle = {
  borderRadius?: number;
  borderLeft?: number;
  borderRight?: number;
  borderTop?: number;
  borderBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
  paddingTop?: number;
  paddingBottom?: number;
};

/**
 * Padding actually rendered for a text block: the user's advanced spacing, raised to the
 * rounded-corner inset when that is larger. Circular blocks get no inset because
 * TextWrapContainer wraps their text to the circle instead.
 */
export const getTextBlockPadding = (style: TextBlockBoxStyle, dimensions: Pick<BlockConfig, 'width' | 'height'>) => {
  const { borderRadius = 0, borderLeft = 0, borderRight = 0, borderTop = 0, borderBottom = 0 } = style;
  const isCircular = borderRadius > 0 && isCircularRadius(borderRadius, dimensions, { borderLeft, borderRight, borderTop, borderBottom });
  const cornerInset = isCircular ? 0 : borderRadius * CORNER_INSET_RATIO;

  return {
    paddingLeft: Math.max(style.paddingLeft ?? 0, cornerInset),
    paddingRight: Math.max(style.paddingRight ?? 0, cornerInset),
    paddingTop: Math.max(style.paddingTop ?? 0, cornerInset),
    paddingBottom: Math.max(style.paddingBottom ?? 0, cornerInset),
  };
};
